import { render, staticRenderFns } from "./HallSchemeCardComponent.vue?vue&type=template&id=52fe4fb6"
import script from "./HallSchemeCardComponent.vue?vue&type=script&lang=js"
export * from "./HallSchemeCardComponent.vue?vue&type=script&lang=js"
import style0 from "./HallSchemeCardComponent.vue?vue&type=style&index=0&id=52fe4fb6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports